<template lang="pug" id="call">
.message-wrapper(:style="{textAlign: textAlign}")
  .message-webchat(v-if="inWebchat")
    .message-avatar(v-if="senderType === 'agents'",)
      img(v-if="avatar"
         :src="avatar" 
         :alt="avatarAltText")
      .no-image(v-else="senderInitials") {{ senderInitials }}
    template(v-if="inWebchat")
      .message-bubble-webchat-container(
        :class="{'message-customer': senderType === 'customers',\
          'message-agent': senderType === 'agents' }")
        .message-bubble_header
            .message-bubble_date
              aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .signature-group
          aiq-col.icon-group(:span="5")
            i.el-icon-edit
          aiq-col.message-group(:span="19")
            div {{ contentMessage }}
            aiq-button.join-btn(size="small" @click="onSign") {{ buttonLabel }}

  .message-container(v-else
                    :class="{'message-customer': senderType === 'customers',\
                            'message-agent': senderType === 'agents' }")
    .message-item(v-if="senderType")
      .message-avatar
        img(v-if="avatar"
           :src="avatar" 
           :alt="avatarAltText")
        .no-image(v-else-if="!avatar && senderInitials") {{ senderInitials }}
        img(v-else 
           :src="photo"
           :alt="avatarAltText")
      .message-bubble
        .message-bubble_header
          .message-bubble_name
            .message-bubble_user-name(v-if="senderType === 'agents'")
              | {{ senderName }}
            i(v-if="senderType === 'customers'",
                :title="channelInfo.title",
                :class="`aiq-ico-conversation-${channel}`")
            .message-bubble_user-name(v-if="senderType === 'customers'")
              | {{ customerName }}
          .message-bubble_date
            aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .signature-group
          aiq-col.icon-group(:span="5")
            i.el-icon-edit
          aiq-col.message-group(:span="19")
            div {{ contentMessage }}
            aiq-button.join-btn(size="small" @click="onSign" disabled) {{ buttonLabel }}


</template>

<script>
import { get } from 'lodash';
import BaseMessage from './BaseMessage/BaseMessage.vue';
import Avatar from '../../Avatar.vue';

export default {
  extends: BaseMessage,
  name: 'signatureMessage',
  components: {
    Avatar,
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({
        payload: {
          message_type: 'signature',
          signature: {
            title: '',
            label: '', // Text to display in button
            integration: '', // Type of integration used
            docusign: null, // docusign payload
            adobesign: null, // adobesign payload
          },
        },
      }),
    },
    inWebchat: Boolean,
  },
  computed: {
    buttonLabel() {
      return this.getString('messages.signature.button', get(this.message, 'payload.signature.label'));
    },
    contentMessage() {
      return this.getString('messages.signature.title', get(this.message, 'payload.signature.title', 'Document'));
    },
  },
  methods: {
    onSign() {
      return this.$emit('signature', this.message);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../aiq-theme/aiq-variables';

.action-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.signature-group {
  color: $aiq-background-main-column-list-item-icon;
  display: flex;
  justify-content: center;
  background-color: white;
  border-radius: 4px;
  margin-top: 3px;
  padding: 5px 30px 5px 10px;
  min-width: 200px;
}

.icon-group {
  padding-top: 10px;
  margin-right: 5px;
}

.message-group {
  padding: 10px 0px;
  color: #67737f;
  display: 'flex';
  justify-content: center;

  .duration {
    font-size: 12px;
    color: rgba(103, 115, 127, 1);
  }

  .join-btn {
    margin-top: 5px;
  }
}
</style>
